import axios from 'axios';

import AskPost from './AskPost';

let dev = 'https://huibaifen.rup-china.com/';
let prod = 'https://portal.huibaifen.com/';

let host;

if (process.env.REACT_APP_ENV === 'production') {
  host = prod;
} else {
  host = dev;
}

const testOpenId = {
  fengtao: 'ohblj1rlHAQBUShMaMhq1nY6pwvg',
  // test : "ohblj1ocR_MnACi--jZSLq9-WHGk",
  test: 'ohblj1mK9z1upnxeG08JXaapUKnQ',
  kejiangtao: 'ohblj1sj14WwkUSgbsl1INaHhzHo',
  unionid: 'oZL5w1qyW4cN2i8h0ElLClyPBkrg',
};

// 实例化 ajax请求对象
const ajaxinstance = axios.create({
  baseURL: host,
  timeout: 5000,
  // withCredentials: true,
  headers: {
    // responseType: 'JSON',
    // 'Content-Type': 'application/json'
    // openid: process.env.REACT_APP_ENV === 'test' ? testOpenId.test : '',
    unionid: process.env.REACT_APP_ENV === 'test' ? testOpenId.unionid : '',
  },
  withCredentials: true,
});

// 添加拦截器，处理 公用请求参数，和通用请求头部
ajaxinstance.interceptors.request.use(
  (config) => {
    // TODO
    console.log(config);

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// 请求响应拦截器
ajaxinstance.interceptors.response.use(
  (response) => {
    // TODO
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * [API api接口封装]
 * @type {Object}
 */
const API = {
  ...AskPost(ajaxinstance),
};

export default API;
